import React from "react";
import './MinimalHeaderComponent.scss'
import {IMinimalHeaderProps} from "./MinimalHeaderComponent.types";
import {Col, Layout ,Row} from 'antd';
import TransferenceLink from "../TransferenceLink/TransferenceLinkComponent";

const { Header } = Layout;

const MinimalHeaderComponent = ({ showLink, transferenceHref, centerLogo }:IMinimalHeaderProps) =>{

  return(
      <Header className={`MinimalComponentBlue`} >
        <div className={`MinimalComponentBlue`} style={{display:`${ centerLogo == true  ? 'flex' : ''}`, justifyContent:'center'}}>
          <Row justify="start">
            <Col span={12}>
              <img className={'MinimalHeaderComponent_autofactLogo_default'} src={"https://static.retail.autofact.cl/img/logo/logo-autofact.svg"}  alt={'AutofactLogo'}/>
            </Col>
            {
              showLink ? 
              <Col span={12} className={'center-end-vertical-items'} style={{paddingTop:'6px'}}>
                <TransferenceLink transferenceHref={transferenceHref} title="Transferir ahora..."></TransferenceLink>
              </Col> : null
            }
          </Row>
        </div>
      </Header>
  )
}

export default MinimalHeaderComponent;
